import { http } from '../../../../api/axios';
import { shopPrefix } from '../../../../config';
import { FeaturedPageOut } from '../../../../store/api';

export const fetchLibraryManagedProductGroupsFeaturedPages = () => {
    return http
        .get<FeaturedPageOut[]>(`${shopPrefix}/v1/librarymanaged/featured-pages`)
        .then(response => response.data);
};
